// Random number generator - requires a PRNG backend, e.g. prng4.js

// For best results, put code like
// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
// in your main HTML document.
import { Arcfour } from './prng4';

export class RNG {
    private rng_state: Arcfour;
    private rng_pool: any;
    private rng_pptr: any;

    constructor() {
        // Initialize the pool with junk if needed.
        if (this.rng_pool == null) {
            this.rng_pool = new Array();
            this.rng_pptr = 0;
            var t;
            if (window.crypto && window.crypto.getRandomValues) {
                // Use webcrypto if available
                var ua = new Uint8Array(32);
                window.crypto.getRandomValues(ua);
                for (t = 0; t < 32; ++t)
                    this.rng_pool[this.rng_pptr++] = ua[t];
            }
            //if (navigator.appName == "Netscape" && navigator.appVersion < "5" && window.crypto) {
            //    // Extract entropy (256 bits) from NS4 RNG if available
            //    var z = window.crypto.random(32);
            //    for (t = 0; t < z.length; ++t)
            //        this.rng_pool[this.rng_pptr++] = z.charCodeAt(t) & 255;
            //}
            while (this.rng_pptr < Arcfour.rng_psize) {  // extract some randomness from Math.random()
                t = Math.floor(65536 * Math.random());
                this.rng_pool[this.rng_pptr++] = t >>> 8;
                this.rng_pool[this.rng_pptr++] = t & 255;
            }
            this.rng_pptr = 0;
            this.rng_seed_time();
            //rng_seed_int(window.screenX);
            //rng_seed_int(window.screenY);
        }
    }

    // Mix in the current time (w/milliseconds) into the pool
    private rng_seed_time() {
        this.rng_seed_int(new Date().getTime());
    }

    // Mix in a 32-bit integer into the pool
    private rng_seed_int(x: any) {
        this.rng_pool[this.rng_pptr++] ^= x & 255;
        this.rng_pool[this.rng_pptr++] ^= (x >> 8) & 255;
        this.rng_pool[this.rng_pptr++] ^= (x >> 16) & 255;
        this.rng_pool[this.rng_pptr++] ^= (x >> 24) & 255;
        if (this.rng_pptr >= Arcfour.rng_psize) this.rng_pptr -= Arcfour.rng_psize;
    }

    private rng_get_byte() {
        if (this.rng_state == null) {
            this.rng_seed_time();
            this.rng_state = new Arcfour();
            this.rng_state.init(this.rng_pool);
            for (this.rng_pptr = 0; this.rng_pptr < this.rng_pool.length; ++this.rng_pptr)
                this.rng_pool[this.rng_pptr] = 0;
            this.rng_pptr = 0;
            //rng_pool = null;
        }
        // TODO: allow reseeding after first request
        return this.rng_state.next();
    }

    public rng_get_bytes(ba: any) {
        var i;
        for (i = 0; i < ba.length; ++i) ba[i] = this.rng_get_byte();
    }
}